import { render, staticRenderFns } from "./Padding.vue?vue&type=template&id=0453c575&scoped=true&"
import script from "./padding.ts?vue&type=script&lang=ts&"
export * from "./padding.ts?vue&type=script&lang=ts&"
import style0 from "./Padding.vue?vue&type=style&index=0&id=0453c575&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453c575",
  null
  
)

export default component.exports